// app/ru/shop/cart/page.js
"use client";
import dynamic from "next/dynamic";

const Cart = dynamic(() => import("@/app/components/catalog/Cart"), { ssr: false });

export default function CartPage() {
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="w-full max-w-[1536px] px-4">
                <main className="flex flex-col justify-between md:pt-16 mx:pt-14 pt-4">
                    <Cart />
                </main>
            </div>
        </div>
        );
}
